<template>
	<div>
		<vxe-modal v-model="modalShow" width="1200" height="800" show-footer destroy-on-close @show="show" @hide="hide"
			transfer :lock-scroll="false" show-zoom resize fullscreen :loading="loading">
			<template #title>
				<div>采购建议</div>
			</template>
			<template #default>
				<div>
					<div style="color: red;font-size: 16px;">【1.价格优先】价格最优
						【2.地域优先】最优价格供应商不在浙江省，但浙江省存在供应商且价格与最优价格相差5%以内（标红）</div>
					<vxe-toolbar>
						<template #buttons>
							<vxe-form :data="form">
								<vxe-form-item title="供应商" field="supplier" :item-render="{}">
									<template #default="{ data }">
										<vxe-input v-model="data.supplier" placeholder="" clearable
											@input="search"></vxe-input>
									</template>
								</vxe-form-item>
								<vxe-form-item title="单据编码" field="billCode" :item-render="{}">
									<template #default="{ data }">
										<vxe-input v-model="data.billCode" placeholder="" clearable
											@input="search"></vxe-input>
									</template>
								</vxe-form-item>
								<!-- 							<vxe-form-item>
										<template #default>
											<vxe-button status="primary" content="查询" @click="search"></vxe-button>
										</template>
									</vxe-form-item> -->
							</vxe-form>
							<vxe-button status="success" size="mini" @click="openExportEvent">导出</vxe-button>
							<!-- <vxe-button status="danger" size="mini" @click="reportingGoods">报货</vxe-button> -->
							<vxe-button status="primary" size="mini" @click="uploadwln">上传万里牛</vxe-button>
							<vxe-button status="danger" size="mini" @click="checkotherinventory">检查CD品他仓库存</vxe-button>
						</template>
					</vxe-toolbar>

					<vxe-table :column-config="{resizable: true}" keep-source
						:row-config="{isCurrent: true, isHover: false}" :edit-config="{trigger: 'click', mode: 'cell'}"
						border :data="data" size="mini" height="600" ref="suggestTable" :export-config="{}"
						v-loading="loading" :tooltip-config="{enterable:true,showAll:true}" :cell-style="cellStyle">
						<vxe-column type="checkbox" width="60" fixed="left"></vxe-column>
						<vxe-column type="seq" width="60" fixed="left"></vxe-column>
						<vxe-column field="goodscode" title="商品编码" width="100" sortable ></vxe-column>
						<vxe-column field="goodsname" title="商品名称" width="100" sortable ></vxe-column>
						<vxe-column field="goodsmodel" title="商品型号" width="100" ></vxe-column>
						<vxe-column field="weight" title="商品重量" width="100"></vxe-column>
						<vxe-column field="recommendlevel" title="推荐等级" width="100"></vxe-column>
						<vxe-column field="requirement" title="锁定库存" width="100"></vxe-column>
						<vxe-column field="stock" title="实际库存" width="100"></vxe-column>
						<vxe-column field="warehousename" title="仓库" width="100" sortable>
							<!-- 						<template #default="{ row }">
									<span>{{row.warehousename+'（'+row.warehousecode+'）'}}</span>
								</template> -->
						</vxe-column>
						<vxe-column field="bottom" title="下限" width="100"></vxe-column>
						<vxe-column field="top" title="上限" width="100"></vxe-column>
						<vxe-column field="custombottom" title="自定义下限" width="100"></vxe-column>
						<vxe-column field="customtop" title="自定义上限" width="100"></vxe-column>
						<vxe-column field="policytype" title="策略类型" width="100">
							<template #default="{ row }">
								<span>{{getEmunValue('policytype', row.policytype)}}</span>
							</template>
						</vxe-column>
						<vxe-column field="suggestnum" title="建议采购数量" width="100"></vxe-column>
						<vxe-column field="currentpolicy" title="供应商" width="200" :edit-render="{}" sortable
							:filters="supplierOptions" :filter-method="supplierFilterMethod">
							<template #edit="{ row }">
								<vxe-select v-model="row.currentpolicy" transfer
									@change="currentpolicyChange(row.currentpolicy,row.supplier,row)">
									<!-- 								<vxe-option v-for="(item,index) in row.supplier" :key="index" :value="item.policyid"
											:label="item.policyid==row.suggestpolicy?item.suppliername+'（'+item.suppliercode+'）【价格优先】':item.suppliername+'（'+item.suppliercode+'）'">
										</vxe-option> -->
									<vxe-option v-for="(item,index) in row.supplier" :key="index" :value="item.policyid"
										:label="supplierOptionsLabel(row,item)">
									</vxe-option>
								</vxe-select>
							</template>
							<template #default="{ row }">
								<span>{{ formatCurrentpolicy(row.currentpolicy,row.supplier,row) }}</span>
							</template>
						</vxe-column>
						<vxe-column field="province" title="供应商省份" width="100">
							<template #default="{ row }">
								<span>{{getEmunValue('city', row.province)}}</span>
							</template>
						</vxe-column>

						<vxe-column field="price1" title="采购价格" width="100" sortable></vxe-column>
						<vxe-column field="amount" title="小计" width="100">
							<template #default="{ row }">
								<span>{{ (row.price1 * row.purchasenum).toFixed(2) }}</span>
							</template>
						</vxe-column>
						<!-- 					<vxe-column field="boxgauge" title="盒规" width="100"></vxe-column>
							<vxe-column field="bingauge" title="箱规" width="100"></vxe-column> -->


						<vxe-column field="getday" title="到仓天数" width="100"></vxe-column>

						<!-- 					<vxe-column field="bestpurchasemark" title="盒/箱规采购建议" width="250" fixed="right" sortable>
								<template #default="{ row }">
									<span v-if="row.bestpurchaseerror" style="color: #F56C6C;">{{ row.bestpurchasemark }}</span>
									<span v-else>{{ row.bestpurchasemark }}</span>
								</template>
							</vxe-column> -->
						<vxe-column field="buynum" title="近一年购买次数" fixed="right" width="100"></vxe-column>		
						<vxe-column field="prochasestandards" title="采购标准" fixed="right" width="100"></vxe-column>
						<vxe-column field="purchasenum" title="本次采购数量" width="100" fixed="right" :edit-render="{}">
							<template #edit="{ row }">
								<el-input type="number" size="mini" v-model="row.purchasenum"
									@blur="computebestunit(row)" label="" @input="computeweight(row)"></el-input>
								<!-- <vxe-input v-model="row.purchasenum" placeholder="" @blur="computebestunit(row)"></vxe-input> -->
							</template>
						</vxe-column>
						<vxe-column field="customizedday" title="定做天数" fixed="right" width="100"></vxe-column>
						<vxe-column field="purchaseweight" title="本次采购重量(kg)" fixed="right" width="100"></vxe-column>
						<vxe-column field="warning" title="预警" fixed="right" width="100">
							<template #default="{ row }">
								<span style="color: #F56C6C;">{{ row.warning }}</span>
							</template>
						</vxe-column>
						<vxe-column field="mark" title="备注" width="100" fixed="right" :edit-render="{}">
							<template #edit="{ row }">
								<vxe-input v-model="row.mark" placeholder=""></vxe-input>
							</template>
						</vxe-column>
						<vxe-column field="otherinventory" title="他仓总库存" width="100" fixed="right"></vxe-column>
						<vxe-column field="billCode" title="采购订单" width="150" fixed="right"
							:filters="billCodeOptions"></vxe-column>

						<vxe-column title="操作" width="100" show-overflow fixed="right" align="center">
							<template #default="{ row }">
								<vxe-button status='primary' mode="text" @click="stock(row)">库存</vxe-button>
							</template>
						</vxe-column>

					</vxe-table>
				</div>
				<!-- 			<transition name="el-fade-in-linear">
						<div class="full flex form_loading" v-if="loading"
							style="background-color: white;z-index: 999;color: #409EFF;">
							<i class="vxe-icon-refresh roll"></i>
							<span>正在加载</span>
						</div>
					</transition> -->
			</template>
			<template #footer>
				<vxe-button status="" content="取消" @click="modalShow=false"></vxe-button>
				<vxe-button status="primary" content="保存" @click="submit"></vxe-button>
			</template>
		</vxe-modal>


		<inventory-index :warehousewlnid="warehousewlnid" :goodscode="goodscode" ref="inventoryIndex" />
	</div>
</template>
<style>

</style>
<style scoped>
	.el-form-item {
		margin-bottom: 0px;
	}

	.form_loading {
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
</style>
<script>
	import inventoryIndex from './lib/inventory.vue'

	export default {
		name: 'suggestIndex',
		props: {
			extra: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				form: {
					supplier: '',
					billCode: '',
				},
				loading: false,
				modalShow: true,
				allAlign: 'center',
				data: [],
				sourceData: [],
				supplierOptions: [],
				billCodeOptions: [],
				goodscode: null,
				warehousewlnid:null

			}
		},
		watch: {

		},
		created() {
			this.list()
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			stock(row) {
				this.goodscode = row.goodscode
				this.warehousewlnid = row.warehousewlnid
				this.$refs.inventoryIndex.modal_show()
				//console.log(row)
			},
			cellStyle({
				row
			}) {
				if (row.locationnotice && row.province) {
					return {
						backgroundColor: 'rgb(253, 226, 226)'
					}
				}
			},
			supplierOptionsLabel(row, option) {
				if (option.policyid == row.suggestpolicy) {
					if(row.policytype == 311){
						return option.suppliername + '（' + option.suppliercode + '）【综价'+ option.comprehensiveJson.comprehensiveprice +'】【价格优先】'
					}else{
						return option.suppliername + '（' + option.suppliercode + '）【综价'+ option.comprehensiveJson.comprehensiveprice +'】'
					}
					
				}
				if (option.locationnotice == 1) {
					return option.suppliername + '（' + option.suppliercode + '）【综价'+ option.comprehensiveJson.comprehensiveprice +'】【地域优先】'
				}

				return option.suppliername + '（' + option.suppliercode + '）【综价'+ option.comprehensiveJson.comprehensiveprice +'】'
			},
			computeweight(row) {
				row.purchaseweight = (row.purchasenum * row.weight).toFixed(6)
				if (row.purchasenum * 1.2 > row.top) {
					row.warning = '本次采购数量异常【超过上限1.2倍】'
				} else {
					row.warning = ''
				}
			},
			computebestunit(row) {
				//console.log(row)
				this.loading = true
				this.$api.purchase.computebestunit({
					total: row.purchasenum,
					binQty: row.bingauge,
					boxQty: row.boxgauge,
					recommendlevel: row.recommendlevel
				}).then((res) => {
					this.loading = false
					if (res.exist) {
						let strarr = [
							'计划采购数量' + row.purchasenum,
							'建议购买' + res.bin + '【箱】' + res.box + '【盒】',
							'按盒规购买量' + res.total + ' 余量' + res.diff,
						]
						row.bestpurchaseerror = 0
						if (res.error) {
							row.bestpurchaseerror = 1
							strarr.push(res.error)
						}
						row.computebestunit = res
						row.bestpurchasemark = strarr.join(' | ')
					} else {
						row.bestpurchasemark = null
						row.computebestunit = null
					}


					//console.log(res)
				}, () => {
					row.bestpurchasemark = null
					row.computebestunit = null
					this.$message.error('计算失败')
					this.loading = false
				})
			},
			search() {
				//console.log(this.form)

				this.data = this.sourceData.filter((item) => {
					item.billCode = item.billCode ? item.billCode : ''
					return this.policy2supplier(item).suppliername.includes(this.form.supplier) && item.billCode
						.includes(this.form.billCode)

				})


			},
			policy2supplier(row) {
				let supplierid = 0
				let suppliername = ''
				row.supplier.forEach((item) => {
					if (item.policyid == row.currentpolicy) {
						supplierid = item.supplierid
						suppliername = item.suppliername
					}
				})
				// console.log({
				// 	supplierid: supplierid,
				// 	suppliername: suppliername
				// })
				return {
					supplierid: supplierid,
					suppliername: suppliername
				}
			},
			customSortMethod({
				data,
				sortList
			}) {
				const sortItem = sortList[0]
				//console.log(data, sortItem)
				const {
					field,
					order
				} = sortItem
				let list = []
				if (order === 'asc' || order === 'desc') {
					if (field === 'currentpolicy') {
						list = data.sort((a, b) => {
							return this.policy2supplier(a).supplierid - this.policy2supplier(b).supplierid
						})
					} else {
						list = data.sort()
					}
				}
				if (order === 'desc') {
					list.reverse()
				}
				return list
			},

			supplierFilterMethod({
				value,
				row
			}) {
				//console.log(row.supplier,value,this.supplierOptions)
				for (let i = 0; i < row.supplier.length; i++) {
					if (row.supplier[i].suppliercode == value && row.supplier[i].policyid == row.currentpolicy) {
						return row
					}
				}

			},
			getEmunValue(field, value) {
				return window.systemMethods.getEmunValue(field, value)
			},
			list() {
				this.loading = true
				this.$api.purchase.list({
					purchaseid: this.extra.purchaseid,
					suggest: 1
				}).then((res) => {
					let supplier = []
					this.supplierOptions = []
					this.billCodeOptions = []
					this.data = res.list
					this.sourceData = res.list
					res.list.forEach((item) => {
						let exist = this.billCodeOptions.findIndex((bil) => {
							return bil.value == item.billCode
						})
						if (exist === -1) {
							this.billCodeOptions.push({
								label: item.billCode,
								value: item.billCode,
								index: item.billCode ? 0 : 1
							})
						}
						this.checklocationsupplier(item)
						supplier = supplier.concat(item.supplier)
					})
					this.billCodeOptions = this.billCodeOptions.sort((a, b) => {
						return b.index - a.index
					})


					supplier.forEach((item) => {
						let exist = this.supplierOptions.findIndex((sup) => {
							return sup.value == item.suppliercode
						})
						if (exist === -1) {
							this.supplierOptions.push({
								label: item.suppliername,
								value: item.suppliercode
							})
						}
					})
					//console.log(supplier,this.supplierOptions)
					if (this.$refs.suggestTable) {
						this.$refs.suggestTable.setFilter('currentpolicy', this.supplierOptions)
						this.$refs.suggestTable.setFilter('billCode', this.billCodeOptions)
					}


					this.loading = false
				})
			},
			checklocationsupplier(row) {
				let location = 5549
				row.locationnotice = 0
				if (row.province != location) {
					row.supplier.forEach((item) => {
						item.locationnotice = 0
						if (item.province == location && row.price1 / item.price1 > 0.95) {
							item.locationnotice = 1
							row.locationnotice = 1
						}
					})
				}
			},
			show() {

			},
			hide() {
				this.back('cancle')
			},
			submit(close = true) {

				return new Promise((reslove) => {
					let postData = []
					let data = this.$refs.suggestTable.getRecordset()
					if (data.updateRecords.length != 0) {
						data.updateRecords.forEach((item) => {
							postData.push({
								id: item.id,
								currentpolicy: item.currentpolicy,
								province: item.province,
								purchasenum: item.purchasenum,
								mark: item.mark,
								warning: (item.top * 1.2 < item.purchasenum) ?
									'本次采购数量异常【超过上限1.2倍】' : "",
								bestpurchasemark: item.bestpurchasemark,
								computebestunit: item.computebestunit,
								bestpurchaseerror: item.bestpurchaseerror
							})
						})
						this.$api.purchase.updateSuggest({
							data: postData
						}).then(() => {
							if (close) {
								this.$message.success('操作成功')
								this.back('cancle')
							}
							reslove()
						})

					} else {
						if (close) {
							this.back('cancle')
						}
						reslove()
					}
				})

				//this.back('cancle')
			},
			back(type) {
				this.$emit('back', {
					type: type
				})
			},
			formatCurrentpolicy(value, supplier, row) {
				for (let i = 0; i < supplier.length; i++) {
					if (supplier[i].policyid == value) {
						if (supplier[i].locationnotice) {
							return supplier[i].suppliername + '（' + supplier[i].suppliercode + '）【综价'+ supplier[i].comprehensiveJson.comprehensiveprice +'】【地域优先】'
						}
						if (value == row.suggestpolicy) {
							// return supplier[i].suppliername + '（' + supplier[i].suppliercode + '）【综价'+ supplier[i].comprehensiveJson.comprehensiveprice +'】【价格优先】'
							if(row.policytype == 311){
								return supplier[i].suppliername + '（' + supplier[i].suppliercode + '）【综价'+ supplier[i].comprehensiveJson.comprehensiveprice +'】【价格优先】'
							}else{
								return supplier[i].suppliername + '（' + supplier[i].suppliercode + '）【综价'+ supplier[i].comprehensiveJson.comprehensiveprice +'】'
							}
							
						}
						return supplier[i].suppliername + '（' + supplier[i].suppliercode + '）【综价'+ supplier[i].comprehensiveJson.comprehensiveprice +'】'
					}

				}
			},
			currentpolicyChange(value, supplier, row) {
				for (let i = 0; i < supplier.length; i++) {
					if (supplier[i].policyid == value) {
						row.price1 = supplier[i].price1
						row.buynum = supplier[i].buynum
						row.customizedday = supplier[i].customizedday
						row.getday = supplier[i].getday
						row.bingauge = supplier[i].bingauge
						row.boxgauge = supplier[i].boxgauge
						row.province = supplier[i].province
						break;
					}
				}
			},
			openExportEvent() {
				let fullData = this.$refs.suggestTable.getTableData().fullData
				fullData = JSON.parse(JSON.stringify(fullData))
				fullData.forEach((item) => {
					item.policytype = item.policytype == 311 ? '备货采购' : '紧急采购'
					let supplier = item.supplier.find((sp) => {
						return sp.policyid == item.currentpolicy
					})
					if (supplier) {
						if (item.currentpolicy == item.suggestpolicy) {
							item.currentpolicy = supplier.suppliername + '（' + supplier.suppliercode + '）推荐'
						} else {
							item.currentpolicy = supplier.suppliername + '（' + supplier.suppliercode + '）'

						}

					}

				})
				this.$refs.suggestTable.exportData({
					filename: '建议采购',
					type: 'xlsx',
					data: fullData,
				})
				// this.$refs.suggestTable.openExport()
			},
			checkotherinventory() {
				let fullData = this.$refs.suggestTable.getTableData().fullData
				let useabledata = fullData.filter((item) => {
					return item.recommendlevel == 'C' || item.recommendlevel == 'D'
				})
				if (useabledata.length) {
					this.loading = true
					useabledata = useabledata.map((item) => {
						return {
							id: item.id,
							goodscode: item.goodscode,
							warehousewlnid:item.warehousewlnid
						}
					})
					this.$api.purchase.checkotherinventory({
						data: useabledata,
						warehousewlnid: useabledata[0].warehousewlnid
					}).then((res) => {
						this.loading = false
						fullData.forEach((item)=>{
							item.otherinventory = item.otherinventory?0:item.otherinventory
							res.forEach((_item)=>{
								if(item.goodscode == _item.goodscode){
									if(!item.otherinventory){
										item.otherinventory = 0
									}
									item.otherinventory += _item.quantity
								}
							})
						})
						
						
						this.$message.success('操作成功')
					}, () => {
						this.loading = false
					})

				} else {
					this.$message.error('暂无CD品')
					return
				}

			},
			uploadwln() {
				this.submit(false).then(() => {
					let data = this.$refs.suggestTable.getCheckboxRecords()
					if (data.length == 0) {
						this.$message.error('请选择商品')
						return
					}

					this.loading = true
					this.$api.purchase.uploadwln({
						goods: data,
						purchaseid: this.extra.purchaseid,
					}).then(() => {
						this.loading = false
						this.$message.success('操作成功')
					}, () => {
						this.loading = false
					})
				})

			},
			reportingGoods() {
				this.$message.error('待开发')
			}
		},
		components: {
			inventoryIndex
		}
	}
</script>